import type { TenantMemberRole } from "@/types/database";

export function roleLabel(role: TenantMemberRole | null) {
  if (!role) return "No role";
  return role.replaceAll("_", " ");
}
